import React from 'react';
import { Form } from 'antd';
import PropTypes from 'prop-types';
import { DrawerFormActions } from '../../../components/DrawerFormActions/DrawerFormActions';

/**
 * Shared Form content for settings create/update drawers (general-condition, subscription-price).
 * Renders Form with fields and cancel/save actions.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {Object} props.form - The form object.
 * @param {Function} props.onFinish - The function to call when the form is finished.
 * @param {Array} props.fields - The fields to render in the form.
 * @param {Function} props.generateFormItem - The function to generate the form item.
 * @param {string} props.resourceKey - The resource key.
 * @param {Function} props.onClose - The function to call when the form is closed.
 * @returns {JSX.Element} The DrawerFormContent component.
 */
export const DrawerFormContent = ({
  form,
  onFinish,
  fields,
  generateFormItem,
  resourceKey,
  onClose
}) => (
  <Form
    wrapperCol={{ span: 24 }}
    labelCol={{ span: 24 }}
    form={form}
    onFinish={onFinish}
  >
    {fields.map((field) => generateFormItem(resourceKey, field))}
    <DrawerFormActions onClose={onClose} />
  </Form>
);

DrawerFormContent.propTypes = {
  form: PropTypes.shape({}).isRequired,
  onFinish: PropTypes.func.isRequired,
  fields: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  generateFormItem: PropTypes.func.isRequired,
  resourceKey: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired
};
